import React, { ReactNode, useEffect, useRef } from 'react';
import Image from '@/providers/Image';
import { useRouter } from 'next/router';
import useImagePulse from '@/components/media/imagePulseHook';
import { mediaBlurDataUrl, mediaUrlCdn } from '@/utils/media';
import { CoverlWrapper, CoverSection } from './MediaCover.styles';

export interface BannerInternalProps {
  cover: MediaCoverType;
  children?: ReactNode;
}

const MediaCover = ({ cover, children, ...props }: BannerInternalProps) => {
  const ref = useRef<HTMLImageElement>(null);
  const router = useRouter();
  const { className, containerRef, handleOnCompleted } = useImagePulse();

  useEffect(() => {
    const handleRouteStart = (url: string) => {
      if (!ref) return;
      if (ref) {
        ref.current?.classList.remove('img-loaded');
      }
    };

    const handleRouteStop = (url: string) => {
      if (!ref) return;
      if (ref) {
        ref.current?.classList.add('img-loaded');
      }
    };
    router.events.on('routeChangeStart', handleRouteStart);
    router.events.on('routeChangeComplete', handleRouteStop);
    return () => {
      router.events.off('routeChangeStart', handleRouteStart);
      router.events.off('routeChangeComplete', handleRouteStop);
    };
  });

  return (
    <CoverSection>
      <CoverlWrapper className={className} ref={containerRef}>
        <Image
          ref={ref}
          src={mediaUrlCdn({ media: cover, options: { cover: true } })}
          alt={cover?.title || 'Cover'}
          fill
          priority
          fadeInOnBlur
          placeholder={mediaBlurDataUrl({ media: cover })}
          handleOnCompleted={handleOnCompleted}
          {...props}
        />
      </CoverlWrapper>
    </CoverSection>
  );
};

export default MediaCover;
